(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
module.exports = {
  init: function() {
    var app, self;
    self = this;
    Vue.config.devtools = true;
    return app = new Vue({
      el: '#app',
      delimiters: ['[[', ']]'],
      data: {
        cart: cart,
        ship_cost: shipping_cost,
        menuHover: false,
        menuOpen: false,
        drawerOpen: false,
        filtersOpen: false,
        zip: localStorage.getItem('zip') ? localStorage.getItem('zip') : zip,
        zone: localStorage.getItem('zone') ? localStorage.getItem('zone') : '',
        zones: grows_in_zones,
        zipCheck: '',
        zoneCheck: '',
        zoneError: false,
        zipInput: '',
        wishlist: localStorage.getItem('wishlist') ? localStorage.getItem('wishlist').split(',') : [],
        cartItemLoading: null,
        state: {
          code: null,
          name: null
        },
        free_gifts: freeGifts,
        tier_discounts: typeof tier_discounts === 'undefined' ? [] : tier_discounts,
        tier_discount_selected: {}
      },
      computed: {
        inOrOut: function() {
          var value;
          self = this;
          value = false;
          if (this.zone && this.zones) {
            this.zones.forEach(function(z) {
              if (self.zone.indexOf(z) !== -1) {
                return value = true;
              }
            });
          }
          return value;
        },
        generalNotePerZone: function() {
          var note = null
          if (window.general_note_per_zones) {
            if (this.zone) {
              var zone = parseInt(this.zone.replace(/\D/g,''))
              if (window.general_note_per_zones[zone]) {
                note = {
                  text: window.general_note_per_zones[zone].text.replace('[ZIP]', this.zip),
                  date: window.general_note_per_zones[zone].date
                }
              }
            }
          }

          return note;
        }
      },
      watch: {
        'cart.plantsafe': function(val) {
          self = this;
          if (val) {
            return this.addToCart({
              id: this.cart.plantsafe_id,
              quantity: 1
            });
          } else {
            localStorage.setItem('unforce', true);
            return this.cart.items.forEach(function(item) {
              if (item.is_plantsafe) {
                return self.updateQ(item.id + "", 0);
              }
            });
          }
        },
        'cart.warranty': function(val) {
          if (val) {
            return this.addToCart({
              id: this.cart.warranty_id,
              quantity: 1
            });
          } else {
            return this.cart.items.forEach(function(item) {
              if (item.is_warranty) {
                return self.updateQ(item.id + "", 0);
              }
            });
          }
        }
      },
      mounted: function() {
        var state, states;
        self = this;
        if (zip) {
          if (!this.zone) {
            this.assignZip(zip);
          }
        } else {
          if (this.zip) {
            if (!this.zone) {
              this.assignZip(this.zip);
            }
          } else {
            this.$root.request('https://ipapi.co/json/?key=Mmz8eq1PLoryXMlo4Ql4PkWuAY1FnzsZhNCaSbkiH9paWiN2Pi', null, function(res) {
              if (res.postal) {
                localStorage.setItem('zip', res.postal);
                return self.assignZip(res.postal);
              } else {
                return self.zoneError = true;
              }
            });
          }
        }
        if (this.cart.items.length === 0) {
          localStorage.removeItem('unforce');
        }
        this.checkCart();
        states = localStorage.getItem('state');
        if (states) {
          state = states.split(',');
          return this.state = {
            code: state[0],
            name: state[1]
          };
        }
      },
      methods: {
        request: function(url, obj, done, method, parse, type) {
          var xhr;
          if (obj == null) {
            obj = null;
          }
          if (method == null) {
            method = 'POST';
          }
          if (parse == null) {
            parse = true;
          }
          if (type == null) {
            type = null;
          }
          xhr = new XMLHttpRequest;
          xhr.open(method, url);
          xhr.onload = function() {
            if (parse) {
              done(JSON.parse(xhr.response));
            } else {
              done(xhr.response);
            }
          };
          xhr.onerror = function() {
            if (parse) {
              done(JSON.parse(xhr.response));
            } else {
              done(xhr.response);
            }
          };
          if (obj) {
            if (type) {
              return xhr.send(obj);
            } else {
              xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
              return xhr.send(JSON.stringify(obj));
            }
          } else {
            return xhr.send();
          }
        },
        scroll: function(anchor) {},
        updateCart: function() {
          self = this;
          setTimeout(function() {
            return self.cartItemLoading = null;
          }, 100);
          return this.$root.request('/cart?view=json', null, function(res) {
            var add, current;
            self.cart = res;
            add = [];
            current = [];
            res.items.forEach(function(item) {
              if (item.properties['Free Gift']) {
                return current.push(item.id);
              }
            });
            if (self.free_gifts.length) {
              self.free_gifts.forEach(function(gift) {
                if (parseInt(res.total_value) >= (gift.limit * 100) && current.indexOf(gift.id) === -1) {
                  return add.push({
                    id: gift.id,
                    quantity: 1,
                    properties: {
                      'Free Gift': gift.details,
                      _limit: gift.limit
                    }
                  });
                }
              });
            }
            if (self.tier_discounts.length){
              max = 0
              tier_in = false
              
              self.tier_discounts.forEach(function(discount) {
                if (self.cart.total_value >= (discount.min * 100) && discount.min >= max) {
                  max = discount.min
                  tier_in = true
                  self.tier_discount_selected = discount
                  self.cart.total = Shopify.formatMoney(self.cart.total_value - (discount.off * 100))
                }
              })

              if (!tier_in && self.tier_discount_selected) {
                self.tier_discount_selected = {}
                self.cart.total = Shopify.formatMoney(self.cart.total_value)
              }
            }
            if (add.length === 0) {
              return self.checkCart();
            } else {
              return self.addToCart({
                items: add
              });
            }
          }, 'GET');
        },
        checkCart: function() {
          var current, only_upsells, up;
          self = this;
          only_upsells = true;
          up = {
            updates: {}
          };
          current = [];
          this.cart.items.forEach(function(item) {
            if (item.properties['Free Gift']) {
              return current.push(item.id);
            }
          });
          if (self.free_gifts.length) {
            self.free_gifts.forEach(function(gift) {
              if (parseInt(self.cart.total_value) < (gift.limit * 100) && current.indexOf(gift.id) !== -1) {
                return up.updates[gift.id] = 0;
              }
            });
          }
          if (this.cart.items.length) {
            this.cart.items.forEach(function(item) {
              var upsell;
              if (item.is_plantsafe || item.is_warranty) {
                upsell = true;
              } else {
                only_upsells = false;
              }
              if (item.is_plantsafe && item.id !== self.cart.plantsafe_id) {
                up.updates[item.id] = 0;
                up.updates[self.cart.plantsafe_id] = 1;
              }
              if (item.is_plantsafe && item.q > 1) {
                up.updates[item.id] = 1;
              }
              if (item.is_warranty && item.id !== self.cart.warranty_id) {
                up.updates[item.id] = 0;
                up.updates[self.cart.warranty_id] = 1;
              }
              if (item.is_warranty && item.q > 1) {
                return up.updates[item.id] = 1;
              }
            });
            if (only_upsells) {
              return self.request('/cart/clear.js', null, function() {
                return self.updateCart();
              });
            } else {
              if (Object.keys(up.updates).length) {
                return self.updateAttr(up);
              }
            }
          } else {
            if (this.cart.note !== '') {
              return this.updateAttr({
                note: ''
              });
            }
          }
        },
        addToCart: function(data, callback) {
          if (callback == null) {
            callback = null;
          }
          self = this;
          return this.request('/cart/add.js', data, function() {
            document.querySelectorAll('.item.upsell').forEach(function(el) {
              el.classList.add('active')
            })
            if (callback) {
              return callback();
            } else {
              return self.updateCart();
            }
          });
        },
        updateQ: function(id, q, max) {
          if (max == null) {
            max = null;
          }
          self = this;
          max = max ? max : 99999;
          this.cartItemLoading = id;
          if (q <= max) {
            return this.request('/cart/change.js', {
              quantity: q,
              id: id
            }, function() {
              return self.updateCart();
            });
          }
        },
        updateAttr: function(attr, callback) {
          if (callback == null) {
            callback = null;
          }
          self = this;
          return this.request('/cart/update.js', attr, function(res) {
            if (callback) {
              return callback(res);
            } else {
              return self.updateCart();
            }
          });
        },
        addBundle: function(e, id) {
          e.target.classList.add('loading');
          return this.addToCart({
            quantity: 1,
            id: id
          }, function() {
            return location.href = '/cart';
          });
        },
        assignState: function(zip) {
          self = this;
          return this.$root.request('https://api.zippopotam.us/us/' + zip, null, function(res) {
            var place;
            if (res) {
              if (res.places) {
                place = res.places[0];
                self.state = {
                  code: place['state abbreviation'],
                  name: place['state']
                };
                return localStorage.setItem('state', place['state abbreviation'] + ',' + place['state']);
              }
            }
          }, 'GET');
        },
        assignZip: function(zip) {
          self = this;
          self.$root.request('https://api.fgtconnections.com/zipzones?zip=' + zip, null, function(res) {
            if (res) {
              if (!res.zone) {
                res = JSON.parse(res);
              }
              self.zone = res.zone;
              return localStorage.setItem('zone', res.zone);
            } else {
              return self.zoneError = true;
            }
          }, 'GET', false);
          return this.assignState(zip);
        },
        saveZip: function() {
          self = this;
          this.$root.request('https://api.fgtconnections.com/zipzones?zip=' + this.zipInput, null, function(res) {
            var data;
            if (!res) {
              self.$refs.ziperror.style.display = 'block';
              return setTimeout(function() {
                return self.$refs.ziperror.style.display = 'none';
              }, 1500);
            } else {
              data = JSON.parse(res);
              self.zip = data.zip;
              self.zone = data.zone;
              localStorage.setItem('zip', data.zip);
              return localStorage.setItem('zone', data.zone);
            }
          }, 'GET', false);
          return this.assignState(this.zipInput);
        },
        deleteZip: function() {
          this.zip = null;
          this.zone = '';
          localStorage.removeItem('zip');
          localStorage.removeItem('zone');
          return localStorage.removeItem('state');
        },
        dropdownOpen: function(e) {
          if (window.outerWidth < 1024) {
            e.preventDefault();
            e.target.nextElementSibling.classList.toggle('show');
            return false;
          } else {
            return true;
          }
        },
        toggleWish: function(handle) {
          if (this.wishlist.indexOf(handle) === -1) {
            this.wishlist.push(handle);
          } else {
            this.wishlist.splice(this.wishlist.indexOf(handle), 1);
          }
          return localStorage.setItem('wishlist', this.wishlist.join(','));
        }
      },
      components: {
        'slider': require('./sliders/_products'),
        'sliderArt': require('./sliders/_articles'),
        'media': require('./sliders/_media'),
        'faq': require('./other/_faq'),
        'tab': require('./other/_tab'),
        'widget': require('./other/_filter'),
        'wishlistItem': require('./other/_wishlist_item'),
        'contact': require('./other/_contact'),
        'product': require('./store/_product'),
        'cart': require('./store/_cart'),
        'account': require('./store/_account'),
        'addresses': require('./store/_addresses')
      }
    });
  },
  scroller: function(e) {},
  resizer: function(e) {}
};


},{"./other/_contact":3,"./other/_faq":4,"./other/_filter":5,"./other/_tab":6,"./other/_wishlist_item":7,"./sliders/_articles":8,"./sliders/_media":9,"./sliders/_products":10,"./store/_account":11,"./store/_addresses":12,"./store/_cart":13,"./store/_product":14}],2:[function(require,module,exports){
app = require('./_app')

window.addEventListener('scroll', app.scroller.bind(app))
window.addEventListener('resize', app.resizer.bind(app))


app.init()
},{"./_app":1}],3:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      issue: ''
    };
  },
  mounted: function() {
    var i, zone, _results;
    this.issue = this.$refs.sel.options[0].value;
    zone = [];
    i = 1;
    _results = [];
    while (i <= 5) {
      zone[i] = document.getElementById('image_' + i).parentElement;
      zone[i].addEventListener('dragenter', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.classList.add('highlight');
      });
      zone[i].addEventListener('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.classList.remove('highlight');
      });
      zone[i].addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
      zone[i].addEventListener('drop', function(e) {
        var src;
        e.preventDefault();
        e.stopPropagation();
        e.target.classList.remove('highlight');
        src = URL.createObjectURL(e.dataTransfer.files[0]);
        e.target.previousElementSibling.files = e.dataTransfer.files;
        e.target.style = 'background-image: url(' + src + ')';
        e.target.parentElement.classList.add('filled');
      });
      _results.push(i++);
    }
    return _results;
  },
  methods: {
    loadFile: function(event, label) {
      var src;
      src = URL.createObjectURL(event.target.files[0]);
      document.querySelector('[for="' + label + '"]').style = 'background-image: url(' + src + ')';
      return document.querySelector('[for="' + label + '"]').parentElement.classList.add('filled');
    },
    remove: function(label) {
      document.querySelector('[name="' + label + '"]').parentElement.classList.remove('filled');
      document.querySelector('[name="' + label + '"]').value = '';
      return document.querySelector('[for="' + label + '"]').style = '';
    },
    submit: function(e) {
      var allow, data, form;
      if (this.$refs.honey.value === '') {
        form = e.target;
        data = new FormData(form);
        data.append('module', 'contact');
        data.append('action', 'add');
        allow = true;
        document.querySelectorAll('.contact-form input[type=file]').forEach(function(input) {
          var size;
          if (typeof input.files[0] !== 'undefined') {
            size = input.files[0].size;
            if (size > 5242880) {
              allow = false;
              return alert(input.name + ' weighs more than 5MB');
            }
          }
        });
        if (allow) {
          form.classList.add('loading');
          form.querySelector('button').innerText = 'Sending...';
          return this.$root.request('https://master.minionmade.net/forms?shop=theplantingtrees.myshopify.com', data, function(res) {
            form.classList.add('sent');
            return form.querySelector('button').innerText = 'Sent';
          }, 'POST', false, 'multipart/form-data');
        }
      }
    }
  }
};


},{}],4:[function(require,module,exports){
module.exports = {
  methods: {
    toggle: function(e) {
      return e.target.classList.toggle('open');
    }
  }
};


},{}],5:[function(require,module,exports){
module.exports = {
  props: ['sorter', 'opened'],
  data: function() {
    return {
      open: this.opened === 'yes' ? true : false,
      tag: ''
    };
  },
  methods: {
    go: function(e) {
      if (this.tag) {
        return location.href = e.target.href.replace('+' + this.tag, '').replace(this.tag, '');
      } else {
        return location.href = e.target.href;
      }
    },
    sortResults: function(handle) {
      var searchParams;
      searchParams = new URLSearchParams(window.location.search);
      searchParams.set('sort_by', handle);
      return window.location.search = searchParams.toString();
    }
  },
  mounted: function() {
    var active;
    if (!this.sorter) {
      active = this.$el.querySelector('.filter-item--active');
      if (active) {
        this.open = true;
        this.tag = active.dataset.handle;
      }
    } else {
      if (location.search.indexOf('sort_by') === -1 && location.search.indexOf('page=') === -1) {
        this.open = true;
      }
    }
    if (!this.$el.querySelector('li')) {
      return this.$el.classList.add('hide');
    }
  }
};


},{}],6:[function(require,module,exports){
module.exports = {
  props: ['opened'],
  data: function() {
    return {
      open: this.opened === 'yes' ? true : false
    };
  }
};


},{}],7:[function(require,module,exports){
module.exports = {
  props: ['handle'],
  data: function() {
    return {
      html: ''
    };
  },
  methods: {
    removeWish: function(e) {
      var wishlist;
      e.target.closest('.item').remove();
      wishlist = localStorage.getItem('wishlist').split(',');
      wishlist.splice(wishlist.indexOf(this.handle), 1);
      return localStorage.setItem('wishlist', wishlist.join(','));
    }
  },
  mounted: function() {
    var self;
    self = this;
    return this.$root.request('/products/' + this.handle + '?view=wish', null, function(res) {
      return self.html = res;
    }, 'GET', false);
  }
};


},{}],8:[function(require,module,exports){
module.exports = {
  methods: {
    slider: function() {
      return tns({
        container: this.$el,
        items: 1,
        gutter: 20,
        nav: false,
        responsive: {
          768: {
            items: 2
          },
          1024: {
            items: 3
          },
          1440: {
            items: 4
          }
        }
      });
    }
  },
  mounted: function() {
    return this.slider();
  }
};


},{}],9:[function(require,module,exports){
module.exports = {
  mounted: function() {
    var main;
    main = tns({
      container: this.$refs.main,
      items: 1,
      nav: false,
      controls: false,
      mouseDrag: true
    });
    tns({
      container: this.$refs.nav,
      items: 5,
      gutter: 10,
      nav: false,
      mouseDrag: true
    });
    return document.body.addEventListener('click', function(e) {
      if (e.target.classList.contains('goto')) {
        return main.goTo(e.target.dataset.index);
      }
    });
  }
};


},{}],10:[function(require,module,exports){
module.exports = {
  props: ['slides'],
  methods: {
    slider: function() {
      return tns({
        container: this.$el,
        items: 2,
        gutter: 20,
        nav: false,
        responsive: {
          768: {
            items: 3
          },
          1024: {
            items: this.slides > 4 ? 4 : this.slides
          },
          1440: {
            items: this.slides ? this.slides : 6
          }
        }
      });
    }
  },
  mounted: function() {
    return this.slider();
  }
};


},{}],11:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      view: 'login'
    };
  },
  mounted: function() {
    if (document.querySelector('[action="/account/recover"] .account-message').length) {
      return this.view = 'recover';
    }
  }
};


},{}],12:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      popup: null
    };
  },
  methods: {
    forDelete: function(id) {
      return Shopify.CustomerAddress.destroy(id, '');
    }
  },
  mounted: function() {
    return document.querySelectorAll('.account-address-form').forEach(function(el) {
      var countryEl, id, options, provinceEl;
      id = el.dataset.addressId;
      countryEl = "customer_addr_".concat(id, "_country");
      provinceEl = "customer_addr_".concat(id, "_province");
      options = {
        hideElement: "address_province_container_".concat(id)
      };
      return new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
    });
  }
};


},{}],13:[function(require,module,exports){
module.exports = {
  data: function() {
    return {
      note: '',
      gift: false,
      message: '',
      messageOn: false,
      associate: '',
      isgift: false,
      timeout: null,
      picker: null,
      delayed: '',
      state: {
        code: null,
        name: null
      },
      recent: localStorage.getItem('recent') ? JSON.parse(localStorage.getItem('recent')) : [],
    };
  },
  components: {
    'slider': require('./../sliders/_products'),
    'iupsell': {
      props: ['id'],
      data: function() {
        return {
          q: 1,
          loading: false
        }
      },
      methods: {
        buy: function() {
          var self = this;
          this.loading = true;
          this.$root.addToCart({
            quantity: this.q,
            id: this.id
          }, function() {
            self.$root.updateCart();
            self.loading = false;
          })
        }
      }
    }
  },
  methods: {
    toggleDatePicker: function() {
      return this.$refs['calendar-wrapper'].classList.toggle('show');
    },
    removeDelay: function() {
      var self, up;
      self = this;
      this.delayed = '';
      up = {};
      up[39277319585839] = 0;
      return self.$root.updateAttr({
        updates: up
      }, function() {
        self.$root.cart.attributes['Delay Shipping'] = '';
        return self.$root.updateAttr({
          attributes: self.$root.cart.attributes
        });
      });
    },
    associatePicker: function(e) {
      this.$root.cart.attributes["Sales Associate"] = e.target.value;
      return this.$root.updateAttr({
        attributes: this.$root.cart.attributes
      });
    },
    isGift: function(e) {
      if (e.target.checked) {
        this.$root.cart.attributes['gift'] = 'This entire order is a gift';
        return this.$root.updateAttr({
          attributes: this.$root.cart.attributes
        });
      } else {
        this.$root.cart.attributes['gift'] = '';
        this.$root.cart.attributes['Gift Message'] = '';
        return this.$root.updateAttr({
          attributes: this.$root.cart.attributes
        });
      }
    },
    checkOut: function(e) {
      this.$root.cart.attributes.nursery_geo_zip = this.$root.zip
      this.$root.cart.attributes.nursery_geo_zone  = this.$root.zone
      this.$root.cart.attributes.ship_date  = this.$root.cart.items[0].properties._email_delivery_notice
      return this.$root.updateAttr({
        attributes: this.$root.cart.attributes
      }, function() {
        window.location.href = e.target.href
      });
    }
  },
  watch: {
    note: function(val) {
      var self;
      self = this;
      clearTimeout(this.timeout);
      if (val.length > 200) {
        this.note = val.substring(0, 199);
      }
      return this.timeout = setTimeout(function() {
        return self.$root.updateAttr({
          note: self.note
        });
      }, 1000);
    },
    gift: function(val) {
      if (!val) {
        return this.$root.updateAttr({
          note: ''
        });
      }
    },
    message: function(val) {
      var self;
      self = this;
      clearTimeout(this.timeout);
      if (val.length > 200) {
        this.message = val.substring(0, 199);
      }
      return this.timeout = setTimeout(function() {
        self.$root.cart.attributes['Gift Message'] = self.message;
        return self.$root.updateAttr({
          attributes: self.$root.cart.attributes
        });
      }, 1000);
    },
    messageOn: function(val) {
      if (!val) {
        this.$root.cart.attributes['gift'] = '';
        this.$root.cart.attributes['Gift Message'] = '';
        return this.$root.updateAttr({
          attributes: this.$root.cart.attributes
        });
      }
    }
  },
  mounted: function() {
    var data, self, state, states, unforce;
    self = this;
    unforce = localStorage.getItem('unforce');

    if (this.$refs.stick) {
      return new window.Sticky('.sticky', {
        marginTop: 25,
        stickyWrap: true,
        stickyFor: 1024,
        stickyContainer: 'section.cart .sidebar'
      });
    }
    
    if (!unforce) {
      if (this.$root.cart.items.length) {
        data = {
          updates: {}
        };
        data.updates[this.$root.cart.plantsafe_id] = 1;
        this.$root.updateAttr(data);
      }
    }
    if (this.$root.cart.note !== '') {
      this.note = this.$root.cart.note;
      this.gift = true;
    }
    if (this.$root.cart.attributes['Delay Shipping']) {
      this.delayed = this.$root.cart.attributes['Delay Shipping'];
    }
    if (this.$root.cart.attributes['Gift Message']) {
      this.message = this.$root.cart.attributes['Gift Message'];
      this.messageOn = true;
    }
    if (this.$refs.calendar) {
      this.picker = new Datepicker(this.$refs.calendar, {
        autohide: true,
        minDate: new Date(new Date().getTime() + (5 * 24 * 60 * 60 * 1000))
      });
      this.$refs.calendar.addEventListener('changeDate', function(e) {
        var up;
        self.delayed = Datepicker.formatDate(self.picker.getDate(), 'mm/dd/yyyy');
        self.$refs['calendar-wrapper'].classList.remove('show');
        self.$root.cart.attributes['Delay Shipping'] = self.delayed;
        up = {};
        up[39277319585839] = 1;
        return self.$root.updateAttr({
          updates: up
        }, function() {
          self.$root.cart.attributes['Delay Shipping'] = self.delayed;
          return self.$root.updateAttr({
            attributes: self.$root.cart.attributes
          }, function(cart) {
            return cart.items.forEach(function(item, index) {
              var props;
              if (item.id === 39277319585839) {
                props = {};
                props['Delay Shipping'] = self.delayed;
                return self.$root.request('/cart/change.js', {
                  line: index + 1,
                  properties: props
                }, function() {});
              }
            });
          });
        });
      });
    }
    states = localStorage.getItem('state');
    if (states) {
      state = states.split(',');
      return this.$root.state = {
        code: state[0],
        name: state[1]
      };
    } else {
      return this.$root.request('https://ipapi.co/json/?key=Mmz8eq1PLoryXMlo4Ql4PkWuAY1FnzsZhNCaSbkiH9paWiN2Pi', null, function(res) {
        self.$root.state = {
          code: res.region_code,
          name: res.region
        };
        return localStorage.setItem('state', res.region_code + ',' + res.region);
      });
    }
  }
};


},{"./../sliders/_products":10}],14:[function(require,module,exports){
module.exports = {
  props: ['variants', 'first', 'short'],
  data: function() {
    return {
      selected: this.first,
      q: 1,
      loading: false,
      open: false,
      price: Shopify.formatMoney(this.first.price),
      compare_at_price: Shopify.formatMoney(this.first.compare_at_price),
      main: {}
    };
  },
  computed: {
    buy4: function() {
      return Shopify.formatMoney(this.selected.price - this.selected.price * 0.05);
    },
    buy10: function() {
      return Shopify.formatMoney(this.selected.price - this.selected.price * 0.1);
    }
  },
  watch: {
    q: function(val) {
      var max;
      if (!val) {
        return this.q = 1;
      } else {
        max = this.selected.inventory_policy === 'continue' ? 9999 : this.selected.inventory_quantity;
        if (val > max) {
          return this.q = max;
        }
      }
    }
  },
  methods: {
    plus: function() {
      var max;
      max = this.selected.inventory_policy === 'continue' ? 9999 : this.selected.inventory_quantity;
      if (this.q + 1 <= max) {
        return this.q += 1;
      }
    },
    minus: function() {
      if (this.q - 1 > 0) {
        return this.q -= 1;
      }
    },
    select: function(index) {
      var max;
      this.selected = this.variants[index];
      if (this.selected.featured_image) {
        this.main.goTo(this.selected.featured_image.position - 1);
        this.thumb.goTo(this.selected.featured_image.position - 1);
      }
      max = this.selected.inventory_policy === 'continue' ? 9999 : this.selected.inventory_quantity;
      if (this.q > max) {
        this.q = max;
      }
      this.price = Shopify.formatMoney(this.selected.price);
      this.compare_at_price = Shopify.formatMoney(this.selected.compare_at_price);
      return this.open = false;
    },
    add: function() {
      var self;
      self = this;
      this.loading = true;
      var note = this.$root._computedWatchers.generalNotePerZone.value;

      function df(d) {
        return d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
      }

      var _email_delivery_notice_date = df(new Date());

      if (note) {
        var string_date = note.text.split(' to Zip')[0].split(' of ')[1];
        _email_delivery_notice_date = df(new Date(string_date.replace('st','').replace('nd','').replace('rd','').replace('th','')));
      }

      var data = {
        quantity: this.q,
        id: this.selected.id,
        properties: {
          _email_delivery_notice: note ? note.text.split(' to Zip')[0] : window.general_note,
          _email_delivery_notice_date: _email_delivery_notice_date
        }
      }
      if (note) {
        data.properties._growing_zone_release = note.date
      }
      return this.$root.addToCart(data, function() {
        self.$root.updateCart();
        return setTimeout(function() {
          self.$root.drawerOpen = true;
          return self.loading = false;
        }, 300);
      });
    }
  },
  mounted: function() {
    var self;
    self = this;
    this.main = tns({
      container: this.$refs.main,
      items: 1,
      nav: false,
      controls: false,
      mouseDrag: true
    });
    this.thumb = tns({
      container: this.$refs.nav,
      items: 5,
      gutter: 10,
      nav: false,
      mouseDrag: true
    });
    if (this.first.featured_image) {
      this.main.goTo(this.first.featured_image.position - 1);
      this.thumb.goTo(this.first.featured_image.position - 1);
    }
    document.body.addEventListener('click', function(e) {
      if (e.target.classList.contains('goto')) {
        return self.main.goTo(e.target.dataset.index);
      }
    });
    if (this.$refs.stick) {
      return new window.Sticky('.sticky', {
        marginTop: 25,
        stickyWrap: true,
        stickyFor: 1024,
        stickyContainer: '.media'
      });
    }

    /*recents = localStorage.getItem('recent')
    if (!recents) {
      recents = []
    } else {
      recents = JSON.parse(recents)
    }

    found = false
    recents.forEach(function(p) {
      if (p.handle == self.short.handle) {
        found = true
      }
    })

    if (!found) {
      recents.unshift(self.short)
    }

    localStorage.setItem('recent', JSON.stringify(recents.slice(0,4))) */
    
  }
};


},{}]},{},[2])